import React from "react";
import { GrStorage } from "react-icons/gr";

const GrStorageIcon = () => {
    return <GrStorage style={{ width: "24px" }} />;
};

export default GrStorageIcon;
